/**
 * Instant Ship upgrade — keeps the upgrade line honest against the cart.
 *
 * The upgrade is a real $29 line item (Shopify holds money in line items and
 * delivery rates, and the Instant RATE was removed), so it can outlive the
 * product it was bought for. Three ways that happens, all of them ending with
 * a shopper charged for an upgrade on nothing:
 *
 *   1. The parent product is removed and the upgrade line stays behind.
 *   2. The shopper adds the same product twice choosing Instant both times,
 *      leaving two upgrade lines for one order.
 *   3. Quantity is raised on the upgrade line itself, which is meaningless:
 *      one order ships once.
 *
 * This reconciles all three. It never ADDS a line — only the PDP does that,
 * where the shopper actually chose the tier — so a failure here can overcharge
 * nobody, it can only fail to clean up.
 *
 * Config comes from #vg-ship-upgrade-config in layout/theme.liquid.
 */
(function () {
  var cfgEl = document.getElementById('vg-ship-upgrade-config');
  if (!cfgEl) return;
  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg.variantId) return;

  var busy = false;

  function isUpgrade(item) {
    var role = item.properties && item.properties._vg_role;
    /* Match on the stamped role first. Fall back to the variant id so a line
       added before this script shipped, or by some other path, is still
       recognised rather than stranded forever. */
    return role === 'shipping_upgrade' || item.variant_id === cfg.variantId;
  }

  /* What the upgrade lines SHOULD look like: at most one, quantity one, and
     only while something else is in the cart to ship. */
  function plan(cart) {
    var items = cart.items || [];
    var upgrades = [];
    var others = 0;
    items.forEach(function (item, i) {
      if (isUpgrade(item)) upgrades.push({ line: i + 1, qty: item.quantity });
      else others++;
    });
    if (!upgrades.length) return null;

    /* Nothing left to ship: every upgrade line goes. */
    if (others === 0) {
      return upgrades.map(function (u) { return { line: u.line, quantity: 0 }; });
    }

    /* Keep the first, drop the rest, and force it back to quantity one. */
    var updates = [];
    upgrades.forEach(function (u, idx) {
      if (idx > 0) updates.push({ line: u.line, quantity: 0 });
      else if (u.qty !== 1) updates.push({ line: u.line, quantity: 1 });
    });
    return updates.length ? updates : null;
  }

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component').forEach(function (el) {
      if (el.dataset.sectionId) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  /* /cart/change.js takes ONE line per request, and every change reindexes the
     lines after it. Apply highest line first so the indices we hold stay valid. */
  function applyUpdates(updates, done) {
    var ordered = updates.slice().sort(function (a, b) { return b.line - a.line; });
    var ids = sectionIds();

    function step(i) {
      if (i >= ordered.length) return done();
      var body = { line: ordered[i].line, quantity: ordered[i].quantity };
      if (ids.length) body.sections = ids.join(',');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (resp) { step(i + 1, resp); })
        .catch(function () { done(); });
    }
    step(0);
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var updates = plan(cart);
        if (!updates) { busy = false; return; }
        applyUpdates(updates, function () {
          fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (fresh) {
              busy = false;
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: fresh,
                  sourceId: 'vg-ship-upgrade',
                  data: { source: 'vg-ship-upgrade' }
                }
              }));
            })
            .catch(function () { busy = false; });
        });
      })
      .catch(function () { busy = false; });
  }

  document.addEventListener('cart:update', function (e) {
    /* Never react to our own dispatch: that is the infinite loop. */
    if (e.detail && e.detail.data && e.detail.data.source === 'vg-ship-upgrade') return;
    reconcile();
  });

  /* An upgrade line can be left over from a previous visit, where no cart:update
     will ever fire. Sweep once on load. */
  reconcile();
})();
